module.exports = __webpack_public_path__ + "img/1F6B3.cb2d458a.svg";